import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header.component';

import { SigninWithOtpModule } from "./../../../auth/_components/signin-with-otp/signin-with-otp.module";

import { SignUpModule } from "./../../../auth/_components/signup/signup.module";
import { SearchBarModule } from "src/app/modules/shared/_components/search-bar/search-bar.module";


import { AppDownloadPopupComponent } from "./../app-download-popup/app-download-popup.component";
import { RatingPopupComponent } from "./../rating-popup/rating-popup.component";
import { SubscribeNowStripComponent } from '../subscribe-now-strip/subscribe-now-strip.component';

@NgModule({
  declarations: [HeaderComponent, AppDownloadPopupComponent, RatingPopupComponent,SubscribeNowStripComponent
  ],
  imports: [CommonModule,
    SigninWithOtpModule,
    SearchBarModule,
    SignUpModule
  ],
  exports: [HeaderComponent]
})
export class HeaderModule { }